import { render, staticRenderFns } from "./CrmSalonPrizeWheel.vue?vue&type=template&id=b1de1ae2&"
import script from "./CrmSalonPrizeWheel.vue?vue&type=script&lang=js&"
export * from "./CrmSalonPrizeWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports